<template>      
  <v-expansion-panel>        
    <v-expansion-panel-content v-for="group in groupLayers" :key="group.key">      
      <div slot="header">{{layerName(group.key)}}</div>
      <div class="px-2" v-for="layer in group.values" :key="layer.id">        
        <v-switch hide-details class="py-2 sm-switch" @change="$store.myActions.UI_TOGGLE_LAYERMAP_VISIBILITY({layerId:layer.id,uiid})" :input-value="mapState.layermapVisibility[layer.id]" :label="layerName(layer.libelle)" :append-icon="hasConfig(layer)?'mdi-information-variant':''" @click:append="showInfos(layer)" />                
        <map-panel-layer-config :uiid="uiid" :layer="layer" v-show="mapState.layermapVisibility[layer.id]"></map-panel-layer-config>              
       <v-divider />
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
       
</template>
<script>
  import { mapGetters } from 'vuex'
  import { groupBy } from '@/utils/groupBy'
  import MapPanelLayerConfig from '@/components/map/MapPanelLayerConfig'  
import { LayerConfig } from '@/models/ui/LayerConfig'
import { LayerSourceType } from '@/enum/LayerSourceType'
  export default {    
    name: 'MapPanelLayer',
    components: {MapPanelLayerConfig},
     props:{
      uiid:{
          type: String,
          required: true
      }
    },        
    data() {
      return {   
      }
    },
   computed: {
       ...mapGetters([         
        'uistatebyuiid',
        'filterMission',   
        'isOperator',
        'isSysAdmin',
        'currentDetailMission',
        'currentDetailFleet']),        
        //recupere le state de travail
        mapState() {          
          return this.uistatebyuiid(this.uiid) 
        },    
        isDetailMap(){
          return this.uiid.indexOf('MissionDetailMap') == 0
        },
        isFleetMap(){
          return this.uiid.indexOf('FleetDetailMap') == 0
        },        
        isSimulationMap(){
          return this.uiid.indexOf('simulation_') == 0
        },
        selectedFilterEnsIds()
        {
          return this.filterMission?.ensIds?.at(0) ?? undefined
        },
        misEnsIds()
        {
          return this.isDetailMap?(this.currentDetailMission?.mission?.ensId ?? undefined)
                                  :this.isFleetMap?(this.currentDetailFleet?.fleet?.ensId ?? undefined)
                                  :this.isSimulationMap?(this.$store.myGetters.originalAdmMissionGlobal?.ENS_ID ?? undefined)
                                  :this.selectedFilterEnsIds
        },
        groupLayers() {
          return groupBy(this.$store.myGetters.mapLayers.filter(l => (
                                                                        (l.LAY_SCOPE != "MIS" && l.LAY_SCOPE != "MIG") || 
                                                                        (this.isDetailMap && l.LAY_SCOPE == "MIS" && l.MIS_ID == this.currentDetailMission.mission.misId) ||
                                                                        (this.isSimulationMap && l.LAY_SCOPE == "MIG" && l.MIG_ID == this.$store.myGetters.originalAdmMissionGlobal.id)
                                                                    ) 
                                                                  && !(JSON.parse((l.LAY_CONFIG_JSON?.length ?? 0 )>0?l.LAY_CONFIG_JSON:'{}').isBasic)
                                                                  && ((!this.isOperator && !this.isSysAdmin)  || this.misEnsIds == undefined || l.LAY_SCOPE != "ENS" || l.ENS_ID == this.misEnsIds))
                        ,l => l.LAY_SCOPE == 'MIS'?`000 : ${this.currentDetailMission.mission.misLibelle}`:
                              l.LAY_SCOPE == 'MIG'?`000 : ${this.$store.myGetters.originalAdmMissionGlobal.MIG_LIBELLE}`: (l.LAY_GROUP_NAME?? "__ No Group __"))?.sort((a,b) => a.key.localeCompare(b.key) )
        }
    },
    methods: {
      getConfig(layer){
        return this.mapstate?.layermapconfig[layer.id] ?? new LayerConfig(JSON.parse((layer.LAY_CONFIG_JSON?.length ?? 0 )>0?layer.LAY_CONFIG_JSON:'{}'))
      },
      showInfos(layer) {
        const config = this.getConfig(layer)
        this.$store.myActions.UI_SHOW_INFOS_DIALOG({
          title: `${this.layerName(layer.libelle)} Source Information`,
          infos: `Credits : ${config.credit}<br/>Service : ${config.url}<br/>Layer : ${config.layer}`, 
          urlinfos: config.urlInfo
        })
      },
      hasConfig(layer) {        
        const config = this.getConfig(layer)
        return config.type != LayerSourceType.NONE
      },
      layerName(libelle) {
        return libelle?.split(':').pop().trim()
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.v-expansion-panel__header{
  background-color: rgb(235, 235, 235);
  border-bottom: 1px solid #bbb;
}
</style>
